import polishedEm from 'polished/lib/helpers/em';
const em = (value, base) => polishedEm(value, base);
export default em;
